import { isSafari, sleep } from '@ardoq/common-helpers';
import { getClonedDOM } from './exportUtil';
import { getStyles, serializeAndWrapInSVG } from './htmlExport';
import type { ExportTrackingData, GetStyleSheetsFn } from './types';
import * as profiling from '@ardoq/profiling';

const getCanvasOfDOM = async (
  parentElement: HTMLElement,
  viewType: string,
  getStyleSheets: GetStyleSheetsFn,
  mutableTrackingData: ExportTrackingData,
  profilingTransaction: profiling.Transaction
) => {
  parentElement.classList.add('forExport');

  const clonedDOM = await getClonedDOM(
    parentElement,
    viewType,
    mutableTrackingData,
    profilingTransaction
  );
  const width = parentElement.scrollWidth;
  const height = parentElement.scrollHeight;

  parentElement.classList.remove('forExport');
  clonedDOM.style.setProperty('position', 'static');

  const canvas = document.createElement('canvas');
  canvas.id = 'canvasOfDOM';
  canvas.height = height;
  canvas.width = width;
  const img = new Image();
  img.crossOrigin = 'anonymous';
  const wrappedInSVG = serializeAndWrapInSVG(
    profilingTransaction,
    clonedDOM,
    width,
    height,
    await getStyles(clonedDOM, getStyleSheets, '', profilingTransaction)
  );
  img.src = `data:image/svg+xml,${encodeURIComponent(wrappedInSVG)}`;
  await img.decode();
  if (isSafari()) {
    // Safari raises image.onload before the fonts embedded in the SVG URI are loaded. so we need to wait for some async operations to complete.
    // https://stackoverflow.com/questions/63940595/safari-svg-to-canvas-with-embedded-font
    await sleep(0);
  }
  const ctx = canvas.getContext('2d');
  if (ctx) {
    ctx.drawImage(img, 0, 0, width, height);
  }
  return canvas;
};

export { getCanvasOfDOM };
